import React from 'react'
import { AppSelectionBar, AppSelectionBarButton } from "@components"
import { useGlobalMultiple } from "Pages/Admin/GlobalExecution/Reports/@hooks"


export default function GlobalExecutionToolbarSelect({ selectedData, setSelectedRows }) {

	const { handleStopMultipleExecutions, handleRetryMultipleExecutions } = useGlobalMultiple(selectedData, setSelectedRows)

	return <AppSelectionBar count={selectedData?.length || 0} onClear={() => setSelectedRows([])}>
		<AppSelectionBarButton icon="circle-stop" label="Stop" title="Stop multiple executions" onClick={handleStopMultipleExecutions}/>
		<AppSelectionBarButton icon="rotate-right" label="Retry" title="Retry multiple executions" onClick={handleRetryMultipleExecutions}/>
	</AppSelectionBar>
}